export const WEEK_DAYS_SHORT = [
  'mon',
  'tue',
  'wed',
  'thu',
  'fri',
  'sat',
  'sun',
];
export const WEEK_DAYS = [
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
  'Sunday',
];

export const ROWS_TO_RENDER = {
  week: 1,
  month: 4,
};

export const MAX_INTERVAL_COUNT = 2;
